import { createIcon } from '@chakra-ui/icons';

/* eslint-disable */
export const HomeIcon = createIcon({
  displayName: 'HomeIcon',
  viewBox: '0 0 24 24',
  path: (
      <path d="M20.83 8.00999L14.28 2.76999C13 1.74999 11 1.73999 9.72996 2.75999L3.17996 8.00999C2.23996 8.75999 1.66996 10.26 1.86996 11.44L3.12996 18.98C3.41996 20.67 4.98996 22 6.69996 22H17.3C18.99 22 20.59 20.64 20.88 18.97L22.14 11.43C22.32 10.26 21.75 8.75999 20.83 8.00999ZM12.75 18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V15C11.25 14.59 11.59 14.25 12 14.25C12.41 14.25 12.75 14.59 12.75 15V18Z" fill="currentColor"/>
  ),
});

export const GarageIcon = createIcon({
  displayName: 'GarageIcon',
  viewBox: '0 0 28 28',
  path: (
    <>
      <g id="garage-7_1_" fill="currentColor">
        <rect x="1" width="24" height="3"></rect>
        <path d="M24,20V4H2v16H0v1h26v-1H24z M7,20V6h12v14H7z"></path>
        <rect x="8" y="8" width="10" height="1"></rect>
        <rect x="8" y="11" width="10" height="1"></rect>
        <rect x="8" y="14" width="10" height="1"></rect>
        <rect x="8" y="17" width="10" height="1"></rect>
      </g>
    </>
  ),
});

export const TokenIcon = createIcon({
  displayName: 'TokenIcon',
  viewBox: '0 0 64 64',
  path: (
    <>
      <path fill="currentColor" d="M12,32a19.975,19.975,0,0,1,.461-4.235L5.284,23.613a28.023,28.023,0,0,0,0,16.777l7.179-4.141A19.97,19.97,0,0,1,12,32ZM8,34a2,2,0,1,1,2-2A2,2,0,0,1,8,34Z"/>
      <path fill="currentColor" d="M16.987,18.83,9.958,14.764A28.026,28.026,0,0,0,5.971,21.7l7.036,4.07A19.964,19.964,0,0,1,16.987,18.83Z"/>
      <path fill="currentColor" d="M13.011,38.242,5.973,42.3a28,28,0,0,0,3.942,6.878l7.031-4.056A19.963,19.963,0,0,1,13.011,38.242Z"/>
      <path fill="currentColor" d="M25.763,13.009v-8.3a28.01,28.01,0,0,0-14.5,8.5l7.166,4.146A19.988,19.988,0,0,1,25.763,13.009ZM20,9a2,2,0,1,1-2,2A2,2,0,0,1,20,9Z"/>
      <path fill="currentColor" d="M52.621,13.082A28,28,0,0,0,37.763,4.6v8.256a19.972,19.972,0,0,1,7.672,4.373ZM44,13a2,2,0,1,1,2-2A2,2,0,0,1,44,13Z"/>
      <path fill="currentColor" d="M35.763,12.367V4.26a27.8,27.8,0,0,0-8,.06v8.141a19.595,19.595,0,0,1,8-.094Z"/>
      <path fill="currentColor" d="M46.85,45.349l7.044,4.075a28,28,0,0,0,4.047-6.9l-7.03-4.067A19.99,19.99,0,0,1,46.85,45.349Z"/>
      <path fill="currentColor" d="M32,14A18,18,0,1,0,50,32,18.021,18.021,0,0,0,32,14ZM46.489,35.883a15,15,0,1,1-1.5-11.383A14.9,14.9,0,0,1,46.489,35.883Z"/>
      <path fill="currentColor" d="M35.365,19.443a13.08,13.08,0,0,0-3.386-.449,13.041,13.041,0,1,0,3.386.449Z"/>
      <path fill="currentColor" d="M37.763,51.145V59.4a28,28,0,0,0,14.809-8.432l-7.183-4.155A19.963,19.963,0,0,1,37.763,51.145ZM46,53a2,2,0,1,1-2-2A2,2,0,0,1,46,53Z"/>
      <path fill="currentColor" d="M58.637,23.381l-7.163,4.133a19.4,19.4,0,0,1,0,8.96l7.161,4.142a27.933,27.933,0,0,0,0-17.235ZM56,34a2,2,0,1,1,2-2A2,2,0,0,1,56,34Z"/>
      <path fill="currentColor" d="M27.763,51.539V59.68a27.8,27.8,0,0,0,8,.06V51.633a19.595,19.595,0,0,1-8-.094Z"/>
      <path fill="currentColor" d="M50.906,25.532l7.033-4.058a27.99,27.99,0,0,0-4-6.843L46.891,18.7A19.97,19.97,0,0,1,50.906,25.532Z"/>
      <path fill="currentColor" d="M11.215,50.74a28.016,28.016,0,0,0,14.548,8.551v-8.3a20,20,0,0,1-7.382-4.386ZM20,51a2,2,0,1,1-2,2A2,2,0,0,1,20,51Z"/>
    </>
  ),
});

export const SettingsIcon = createIcon({
  displayName: 'SettingsIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path d="M0,0h24v24H0V0z" fill="none" />
      <path
        fill="currentColor"
        d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
      />
    </g>
  ),
});

export const DodgeIcon = createIcon({
  displayName: 'DodgeIcon',
  viewBox: '0 0 300 300',
  path: (
    <>
      <text x="10" y="60" font-size="73" font-family="Arial, sans-serif" font-style="italic" fill="white">DODGE</text>
    </>
  ),
});
